import {
  Button,
  Checkbox,
  LabeledInput,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@apexinternal/ui-components'
import { Stack, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { InfoPopover } from '../../../../components/InfoPopover'
import { AccountDetails } from '../../../../types'
import CloseAccountAlert from './CloseAccountAlert'
import CloseAccountDescription from './CloseAccountDescription'

export interface EditModalContentProps {
  accountDetails: AccountDetails
  isReplacedByFdid: boolean
  fdid: string
  setReplacedByFdid: (isReplacedByFdid: boolean) => void
  setFdid: (fdid: string) => void
  onClose: () => void
  onConfirm: () => void
}

const EditModalContent = ({
  accountDetails,
  isReplacedByFdid,
  fdid,
  setReplacedByFdid,
  setFdid,
  onClose,
  onConfirm,
}: EditModalContentProps) => {
  const [fdidTouched, setFdidTouched] = useState(false)

  const isFdidEmpty = !fdid.trim()
  const isInvalid = fdidTouched && isFdidEmpty
  const hasError = isReplacedByFdid && isFdidEmpty
  return (
    <ModalContent>
      <ModalHeader>Close Account</ModalHeader>
      <ModalCloseButton onClick={onClose} />
      <ModalBody>
        <Stack spacing="1rem">
          <CloseAccountDescription accountDetails={accountDetails} />
          <Text>Please confirm that you would like to close this account.</Text>
          <Stack spacing="1rem">
            <Checkbox
              isChecked={isReplacedByFdid}
              onChange={() => setReplacedByFdid(!isReplacedByFdid)}
              fontWeight="normal"
            >
              This account is being replaced.{' '}
              <InfoPopover description="Replacing accounts must be linked with the FDID to meet CAT regulatory obligations." />
            </Checkbox>
            {isReplacedByFdid && (
              <LabeledInput
                data-testid="fdid"
                errorMessage={isInvalid ? 'Required' : undefined}
                isInvalid={isInvalid}
                isRequired
                label="Replaced by FDID"
                charCounter={40}
                maxLength={40}
                value={fdid}
                onBlur={() => setFdidTouched(true)}
                onChange={e => setFdid(e.target.value)}
              />
            )}
          </Stack>
          <CloseAccountAlert />
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Stack direction="row" spacing={2}>
          <Button variant="white" onClick={onClose} tabIndex={1}>
            Cancel
          </Button>
          <Button
            variant="negative"
            isDisabled={hasError}
            onClick={onConfirm}
            tabIndex={2}
          >
            Confirm Account Closure
          </Button>
        </Stack>
      </ModalFooter>
    </ModalContent>
  )
}

export default EditModalContent
